var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("ContentNodeThumbnail", {
    attrs: { contentNode: _vm.contentNode },
    scopedSlots: _vm._u([
      {
        key: "labels",
        fn: function () {
          return [
            _vm.displayDurationChip
              ? _c("LearningActivityDuration", {
                  staticClass: "duration",
                  attrs: { contentNode: _vm.contentNode, appearance: "chip" },
                })
              : _vm._e(),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }